
import axios from 'axios'
import qs from 'qs'
import gloablConfig from './config.js'
//url


// const BASE_API_URL = 'http://localhost:8686';
// const WEBSOCKET_URL = 'ws://localhost:8686/websocket/';
 // const BASE_API_URL = 'http://82.157.22.84:8686';
 // const WEBSOCKET_URL = 'ws://82.157.22.84:8686/websocket/';
const BASE_API_URL = 'http://www.xcxdtech.com:9000';
const WEBSOCKET_URL = 'ws://www.xcxdtech.com:9000/websocket/';




const USER_CAPTCHA_URL = '/user/captcha';
const USER_LOGIN_URL = '/user/login';
const USER_LOGOUT_URL = '/user/logout';
const USER_MENUS_URL = '/admin/menus';
const WATER_COMPANY_LIST_URL = '/admin/watercompany/list';
const EDIT_WATER_COMPANY_URL = '/admin/watercompany/edit';
const ADD_WATER_COMPANY_URL = '/admin/watercompany/add';
const ROLE_LIST_URL = '/admin/role/list';
const ROLE_AUTHORITY_URL = '/admin/role/authority';
const ROLE_AUTHORITY_ADD_URL = '/admin/role/add';
const ROLE_AUTHORITY_EDIT_URL = '/admin/role/edit';
const USER_ADMIN_LIST_URL = '/admin/list';
const USER_ADMIN_ADD_INFO_URL = '/admin/add/info';
const USER_ADMIN_ADD_URL = '/admin/add/add';
const USER_ADMIN_RESET_PWD_URL = '/admin/resetPassword';
const USER_ADMIN_EDIT_PWD_URL = '/admin/editPassword';
//添加用户时，用户名校验
const USER_ADMIN_ADD_NAMECHECK_URL = '/admin/add/check';

const USER_ADMIN_DELETE_URL = '/admin/delete';
const USER_ADMIN_UPDATE_URL = '/admin/update';
const NEIGHBOR_SEARCH_LIST_URL ='/neighbor/search/list';
const NEIGHBOR_DEPART_LIST_URL ='/neighbor/depart/list';
const NEIGHBOR_DEPART_ADD_URL ='/neighbor/depart/add';
const NEIGHBOR_DEPART_DELETE_URL ='/neighbor/depart/delete';
const NEIGHBOR_DEPART_NEIGHBORS_URL ='/neighbor/depart/neighborList';
const NEIGHBOR_DEPART_NO_ORDER_URL ='/neighbor/depart/neighborListNoOrder';
const NEIGHBOR_LASTEST_LIST_URL = '/neighbor/neighborLastest';
const NEIGHBOR_DEPART_NEIGHBORIDS_URL ='/neighbor/depart/neighbors';
const NEIGHBOR_DEPART_ADD_REL_URL = '/neighbor/depart/addNeighborRel';
const NEIGHBOR_DEPART_DEL_REL_URL = '/neighbor/depart/delNeighborRel';
const NEIGHBOR_GPRS_LIST_URL = '/neighbor/gprs/list';
const NEIGHBOR_GPRS_CHECK_EXIST_URL = '/neighbor/gprs/checkexist';
const NEIGHBOR_GPRS_ADD_URL = '/neighbor/gprs/add';
const NEIGHBOR_GPRS_EDIT_URL = '/neighbor/gprs/edit';
const NEIGHBOR_GPRS_DELETE_URL = '/neighbor/gprs/delete';
const NEIGHBOR_ADD_URL = '/neighbor/add';
const NEIGHBOR_DELETE_URL = '/neighbor/delete';
const NEIGHBOR_UPDATE_URL = '/neighbor/update';
const NEIGHBOR_CHECK_EXIST_URL = '/neighbor/checkexist';
const NEIGHBOR_CONFIG_PERIOD_ADD_URL='/neighbor/gprsConfigPeiord/add';
const NEIGHBOR_CONFIG_PERIOD_DELETE_URL='/neighbor/gprsConfigPeiord/delete';
const NEIGHBOR_CONFIG_PERIOD_GET_URL='/neighbor/gprsConfigPeiord/get';
const NEIGHBOR_CONFIG_PERIOD_UPDATE_URL='/neighbor/gprsConfigPeiord/update';
const NEIGHBOR_LIST_LOU_URL = '/neighbor/louList';
const NEIGHBOR_LIST_DY_URL = '/neighbor/DYList';
const NEIGHBOR_LIST_EXPORT_URL = '/neighbor/exportNeighbors';
const NEIGHBOR_ALL_LIST_URL = '/neighbor/allNeighborList';

//查询欠费列表
const Static_LIST_OWE_URL = '/statis/oweList';
//查询收费率列表
const Static_LIST_ChargePercent_URL = '/statis/chargePercentList';
//查询收费率图表
const Static_LIST_ChargePercentDraw_URL = '/statis/chargePercentListDraw';
//查询撤销记录列表
const Static_LIST_Undo_URL = '/statis/undoLogList';
//发短信提醒欠费用户
const CUSTOMER_SENDSMS_REMIND_URL = '/statis/sendSmsRemind4Customer';
//短信发送记录
const STATIS_LIST_MESSAGE_LOG_URL = '/statis/smsLogList';
//短信发送记录列表通过名字查  分组小区
const STATIS_LIST_MESSAGE_LOG_BYNAME_URL = '/statis/smsLogListByName';
const STATIS_OWE_EXPORT_URL = '/statis/oweListExport';
//结束抄表任务
const STOP_METER_TASK_DETAIL_URL = '/readMeter/finishTaskManualById';

const BASIC_PRICE_LIST_URL = '/system/basicprice/list';
const BASIC_PRICE_ADD_URL = '/system/basicprice/add';
const BASIC_PRICE_DELETE_URL = '/system/basicprice/delete';
const BASIC_PRICE_ADJUST_URL = '/system/basicprice/adjust';
const SMS_TEMPLATE_LIST_URL ='/system/smstemplate/list';
const FAILURE_NOTICE_URL ='/system/failurenotice';
const SCANNING_TASK_LIST_URL = '/system/scantask/list';
const SCANNING_TASK_ADD_URL = '/system/scantask/add';
const SCANNING_TASK_DELETE_URL = '/system/scantask/delete';
const SCANNING_TASK_UPDATE_URL = '/system/scantask/update';
const SCANNING_TASK_CHANGE_URL = '/system/scantask/change';
const SCANNING_TASK_NEIGHBORS_URL = '/system/scantask/neighbors';
const SCANNING_TASK_RECORD_LIST_URL = '/system/scantask/record/ist';
const SCANNING_TASK_ARREARAGE_CUSTOMERS_URL = '/system/scantask/arrearage/customers';
const SCANNING_TASK_SMS_LOGS_URL = '/system/scantask/sms/logs';
const SCANNING_TASK_ARREARAGE_SENDSMS_URL = '/system/scantask/arrearage/sendsms';
const  MAIN_STATIS_URL = '/customer/mainStatis';
const CUSTOMER_LIST_WITH_NEIGHBOR_URL = '/customer/listWithNeighbor';
const CUSTOMER_METER_TRANSFER_URL ='/customer/meterTransfer';
const CUSTOMER_COLLECTORS_WITH_GPRS_URL='/customer/collectorWithGprs';
const CUSTOMER_UPDATE_COLLECTOR_ADDR_URL = '/customer/updateCollectorAddr';
const CUSTOMER_LIST_WITH_NUM_URL = '/customer/listWithNum';
const CUSTOMER_UPDATE_URL = '/customer/update';
const CUSTOMER_DELETE_URL = '/customer/delete';
const CUSTOMER_METERS_URL = '/customer/meters';
const CUSTOMER_METER_ADJUST_URL = '/customer/meterAdjust';
const CUSTOMER_METER_KIND_LIST_URL = '/customer/meterkindList';
const CUSTOMER_METER_UPDTAE_URL = '/customer/meterUpdate';
const CUSTOMER_METER_DELETE_URL = '/customer/meterDelete';
const CUSTOMER_METER_CHECK_EXIST_URL='/customer/meterCheckByAPID';
const CUSTOMER_METER_CHANGE_URL='/customer/meterChange';
const CUSTOMER_METER__CHANGE_HISTORY_URL='/customer/meterChangeHistory';
const CUSTOMER_METER_CHANGE_FAULT_URL = '/customer/meterChangeFault';
const CUSTOMER_CHECK_BY_APID_URL='/customer/checkByAPID';
const CUSTOMER_ADD_URL='/customer/add';
const CUSTOMER_METER_ADD_URL = '/customer/meterAdd';
const CUSTOMER_PRICE_KIND_LIST = '/customer/priceKindList';
const CUSTOMER_BATCH_ADD_URL = '/customer/meterBatchAdd';
const CUSTOMER_ONE_GET_URL = '/customer/getCustomer';
const CUSTOMER_UPDATE_INFO_URL = '/customer/updateCustomerInfo';
const READ_METER_DISPATCH_ADDRESS_URL= '/readMeter/dispatchAddress';
const READ_METER_LIST_URL = '/readMeter/list';
const READ_METER_GPRS_LIST_URL = '/readMeter/getGprsList';
const READ_METER_METER_LIST_URL = '/readMeter/getMeterList';
const READ_METER_UPDATE_READ_URL = '/readMeter/updateMeterRead';
const READ_METER_HISTORY_URL = '/readMeter/readHistory';
const READ_METER_EXPORT_HISTORY_URL = '/readMeter/exportReadHistory';
const READ_METER_4_NEIGHBOR_URL = '/readMeter/readMeterNeighbor';
const READ_METER_4_COLLECTOR_URL = '/readMeter/readMeterCollector';
const READ_METER_4_SINGLE_URL = '/readMeter/readMeterSingle';
const READ_METER_4_CHOSED_URL = '/readMeter/readMeterChosed';
const READ_METER_4_ALL_URL = '/readMeter/readMeterAll';
const READ_METER_TASK_DETAIL_URL = '/readMeter/readMeterTaskDetail';
const READ_METER_EXPORT_NEIGHBOR_EXCEL_URL = '/readMeter/exportNeighborExcel';
const READ_METER_EXPORT_NEIGHBOR_ZIP_URL = '/readMeter/exportNeighborZip';
const READ_METER_EXPORT_ALL_URL = '/readMeter/exportAll';
const READ_METER_EXPORT_ALL_EXCEL_URL = '/readMeter/exportAllExcel';
const READ_METER_TASKDETAIL_LIST_URL = '/readMeter/readMeterTaskDetailList';
const READ_METER_ALL_RESULT_URL = '/readMeter/readMeterAllResult';
const READ_METER_FINISH_TASK_MANUAL_URL = '/readMeter/finishTaskManual';
const READ_METER_RESULT_ANALYSE_URL = '/readMeter/readMeterResultAnalyse';
const READ_METER_RESULT_HANDLE_URL = '/readMeter/readMeterResultHandle';
const READ_NON_REMOTE_METER_LIST_URL = '/readMeter/nonRemoteList';
const READ_METER_LIST_BY_APID_URL = '/readMeter/listByApId';


const NON_REMOTE_EXPORT_URL = '/readMeter/exportNonRemoteExcel';
const NON_REMOTE_READ_LOG_ADD_URL ='/readMeter/addReadMeterLogNonRemote';
const NON_REMOTE_READ_LOG_LIST_URL ='/readMeter/getReadMeterLogsNonRemote';
const NON_REMOTE_READ_DATA_ADD_URL = '/readMeter/addReadMeterManual';
const NON_REMOTE_READ_DATA_UPLOAD_URL = '/readMeter/uploadNonRemote';
const CHARGE_GET_CUSTOMER_INFO_URL = '/charge/customerInfo';
const CHARGE_UPDATE_CUSTOMER_INFO_URL = '/charge/customerInfo/update';
const CHARGE_CHANGE_PREPAYSIGN_URL='/charge/changePrePaySign';
const CHARGE_CHANGE_PREPAYSIGN_LOG_URL='/charge/changePrePaySignLog';
const CHARGE_GET_CUSTOMER_BY_IDCARD_URL = '/charge/customerInfoByIdCard';
const CHARGE_UPDATE_METER_PRICE_URL = '/charge/updatePrice4Meter';
const CHARGE_UPDATE_DEREAD_URL = '/charge/updateDeread4Meter';
const CHARGE_CHARGE_FEE_URL = '/charge/chargeFee';
const CHARGE_CHARGE_LOG_LIST_URL ='/charge/chargeFeeLogList';
const CHARGE_CANCEL_CHARGE_URL = '/charge/chargeFeeCancel';
const CHARGE_DEDUCT_LOG_LIST = '/charge/deductLogList';
const CHARGE_CANCEL_DEDUCT_URL = '/charge/cancelDeductLog';
const CHARGE_MINUS_DEREAD_URL = '/charge/minusDeread';
const CHARGE_MINUS_DEREAD_LOG_LIST_URL = '/charge/minusDereadLogList';
const CHARGE_TO_VIRTUAL_URL = '/charge/toVirtual';
const GET_METER_DEDUCT_STATIS_URL = '/statis/getMeterDeductStatis';
const CHARGE_SETTLE_SEARCH_URL = '/charge/settle/search';
const CHARGE_SETTLE_ALL_USE_COUNT_URL = '/charge/settle/allUseCount';
const CHARGE_SETTLE_SINGLE_URL = '/charge/settle/single';
const CHARGE_SETTLE_ALL_URL = '/charge/settle/all';
const CHARGE_WARNING_ALL_URL = '/charge/settle/warningAll';
const  CHARGE_POST_PAY_SETTLE_LOGS_URL = '/charge/postPay/settleLogs';
const  CHARGE_POST_PAY_LIST_URL = '/charge/postPay/list';
const  CHARGE_POST_PAY_CHARGE_URL = '/charge/postPay/charge';
const  CHARGE_POST_PAY_WARNING_ALL_URL = '/charge/postPay/warningAll';
const  CHARGE_UPDATE_PRICE_LOG_LIST_URL = '/charge/updatePriceLog4Meter';
const CHARGE_SETTLE_EXPORT_EXCEPTION_URL = '/charge/settle/exportException';
const  STATIS_GET_PAY_INFO_STATIS_URL = '/statis/getPayInfoStatis';
const  STATIS_PAY_INFO_STATIS_Print_URL = '/report/PayInfoStatisPrint';
const  STATIS_List_Settle_Log_URL = '/statis/listsettlelog';
const  STATIS_List_Settled_URL = '/statis/listsettled';
const  STATIS_Settlelog_Print_URL = '/report/SettlelogPrint';
const  STATIS_GETLOUS_URL = '/statis/getLous';
const  STATIS_LOULOGALL_URL = '/statis/loulogall';
const  STATIS_LOU_PRINT_URL = '/report/louPrint';
const  STATIS_LARGE_METER_USE_COUNT_URL = '/statis/largeMeterUseCount';
const  STATIS_LARGE_METER_NEIGHBORS_URL = '/statis/largeMeterNeighbors';
const  STATIS_SIX_MONTH_NO_CHANGE_LIST_URL ='/statis/sixMonthNoChangeList';
const  STATIS_SIX_MONTH_NO_CHANGE_EXPORT_URL = '/statis/sixMonthNoChangeExport';
const  STATIS_UNCHARGE_CUSTOMERS_URL = '/statis/problemCustomers';
const  STATIS_UNCHARGE_CUSTOMERS_EXPORT_URL = '/statis/problemCustomersExport';
const  STATIS_WATER_DEDUCT_LIST_URL= '/statis/waterUseDeductList';
const  STATIS_WATER_DEDUCT_STATIS_URL= '/statis/waterUseDeductStatis';
const  STATIS_WATER_DEDUCT_STATIS_ENTERPRISE_URL= '/statis/waterUseDeductStatis4Enterprise';
const  STATIS_WATER_DEDUCT_STATIS_EXPORT_URL= '/statis/waterUseDeductExport';
const  STATIS_WATER_DEDUCT_DRAW_URL= '/statis/waterUseDeductDraw';
const  STATIS_ABNORMAL_CUSTOMER_LIST_URL = '/statis/abnormalCustomer/list';
const  STATIS_ABNORMAL_CUSTOMER_EXPORT_URL = '/statis/abnormalCustomer/export';
const  READ_METER_EXPORT_TYPE_LIST_URL = '/readMeter/exporTypeList';
const  READ_METER_EXPORT_NEIGHBOR_YT_URL = '/readMeter/exportNeighborDBF4YT';
const READ_METER_EXPORT_NEIGHBOR_FS_URL = '/readMeter/exportNeighbor4FS';
const READ_METER_EXPORT_NEIGHBOR_WH_URL = '/readMeter/exportNeighbor4WH';
const READ_METER_EXPORT_NEIGHBOR_RC_URL = '/readMeter/exportNeighbor4RC';
const READ_METER_EXPORT_YT_ALL_URL = '/readMeter/exportAll4YT';
const READ_METER_EXPORT_RC_ALL_URL = '/readMeter/exportAll4RC';
const READ_METER_EXPORT_WH_ALL_URL = '/readMeter/exportAll4WH';
const READ_METER_EXPORT_FS_ALL_URL = '/readMeter/exportAll4FS';
const READ_METER_PATCH_TASK_URL = '/readMeter/addPatchTask';
const READ_METER_REFRESH_METER_URL = '/readMeter/refreshOneMeter';
const READ_METER_RESULT_ANALYSE_EXPORT_URL = '/readMeter/exportMeterResultAnalyse';
const READ_METER_LIHU_FAIL_METER_DATA_URL = '/readMeter/getLiHuFailMeterData';
const READ_METER_LIHU_FAIL_METER_DATA_EXPORT_URL = '/readMeter/exportLihuFailMeterData';
const NEIGHBOR_CHANGE_GPRS_HISTORY_FLAG_URL = '/neighbor/changeGprsHistoryFlag';
const READ_METER_UPDATE_METER_OK_URL = '/readMeter/updateNeighborMeterOK';
const STATIS_DEDUCT_EXPORT_URL = '/statis/deductStatis/export';
const CUSTOMER_EXPORT_URL = '/customer/exportCustomerList';
const SYSTEM_GET_GPRS_ONLINE_LOG_URL ='/system/getGprsOnLineLog';
const SET_METER_VALVE_STATE_URL = '/readMeter/setMeterValueState';
const READ_METER_EXPORT_YT_TOTAL_URL = '/readMeter/exportTotal4YT';
const READ_METER_RECENT_HISTORY_URL = '/readMeter/readHistoryRecent';
const READ_METER_IMPORT_FAILDATA_URL = '/readMeter/importLihuFailMeterData';
const READ_METER_REBOOT_GPRS_URL = '/readMeter/rebootGprs';
const STATIS_MINUS_LIST_URL = '/statis/minusStatis';
const STATIS_MINUS_EXPORT_URL = '/statis/minusStatis/export';
const GET_NB_COLLECTOR_LIST_URL = '/getNBCollector';
const ADD_NB_COLLECTOR_URL='/addNBCollector';
const EDIT_NB_COLLECTOR_URL='/editNBCollector';
const DELETE_NB_COLLECTOR_URL='/deleteNBCollector';
const EXPORT_NB_COLLECTOR_URL  = '/collectorExport';
const DISPATCH_ADDR_NB_COLLECTOR_URL='/dispatchAddress4NBCollector';
const DELETE_NB_COLLECTOR_COMMAND_URL = '/deleteCommand';
const DELETE_NB_COLLECTOR_COMMAND_ID_URL = '/deleteCommandById';
const QUERY_NB_COLLECTOR_COMMAND_URL = '/queryCommandList';


const ELEC_QUERY_METER_LIST_URL='/elec/meterList';
const ELEC_ADD_METER_URL='/elec/addMeter';
const ELEC_ADD_TASK_URL='/elec/addTask';
const GET_METER_USE_COUNT_URL='/readMeter/getMeterUseCount';
const SEND_SETUP_WORK_MODE_COMMAND_URL = "/setupWokeMode4NBCollector";
const SEND_SETUP_UPLOAD_DATE_COMMAND_URL = "/setupUploadDate4NBCollector";

//光电大表监控
const METER_MONITOR_MAP_INFO_URL = "/meterMonitor/mapInfo";
const METER_MONITOR_METER_INFO_URL = "/meterMonitor/meterInfo";
const METER_MONITOR_REAL_TIME_STATIS_URL = "/meterMonitor/realTimeStatis";
const METER_MONITOR_REAL_TIME_STATIS_EXPORT_URL = "/meterMonitor/realTimeStatisExport";
const METER_MONITOR_FLOW_STATIS_URL = "/meterMonitor/flowStatis";
const METER_MONITOR_FLOW_STATIS_EXPORT_URL = "/meterMonitor/flowStatisExport";
const METER_MONITOR_INTERVAL_FLOW_STATIS_URL = "/meterMonitor/intervalFlowStatis";
const METER_MONITOR_LINK_STATUS_URL = "/meterMonitor/linkStatus";
const METER_MONITOR_LINK_EXPORT_URL = "/meterMonitor/linkStatusExport";
const METER_MONITOR_YOY_STATIS_URL = "/meterMonitor/yoyStatis";
const METER_MONITOR_YOY_STATIS_EXPORT_URL ="/meterMonitor/yoyStatis4Export";
const METER_MONITOR_YOY_STATIS_CHART_URL = "/meterMonitor/yoyStatis4Chart";
const METER_MONITOR_EDIT_OVERFLOW_URL = "/meterMonitor/editOverFlow";
const METER_MONITOR_MIN_FLOW_LIST_URL = "/meterMonitor/minFlowDataList";
const METER_MONITOR_ANALYSIS_URL = "/meterMonitor/meterAnalysis";
const METER_MONITOR_MIN_FLOW_LIST_EXPORT_URL = "/meterMonitor/minFlowDataList4Export";
const METER_MONITOR_MIN_FLOW_DETAIL_URL = "/meterMonitor/minFlowDataDetail";
const METER_MONITOR_ALL_LIST_URL = "/meterMonitor/allList";
const METER_MONITOR_ADD_URL = "/meterMonitor/add";
const METER_MONITOR_EDIT_URL = "/meterMonitor/edit";
const METER_MONITOR_QUERY_METER_URL = "/meterMonitor/queryMeterByApId";
const METER_MONITOR_QUERY_DETAIL_URL = "/meterMonitor/queryMeterMonitorDetail";
const METER_MONITOR_DATA_EXPORT_URL = "/meterMonitor/meterMonitorDetail4Export";


const QUERY_GPRS_RESULT_URL = "/neighbor/queryGprs";
const METER_RESET_READ_DATA_URL = "/readMeter/resetReadData";
const METER_FIX_STATUS_URL = "/readMeter/fixMeterStatus";
const QUERY_NBMETER_HISTORY_URL = "/readMeter/queryNBHistory";
const READ_METER_DATA_CONTRAST_URL = "/readMeter/dataContrast";


const COMMON_QUERY_UPDATE_NBCOLLECTOR_METER_URL = "/commonQuery/nbCollectorUpdate";
const COMMON_QUERY_NBCOLLECTOR_METER_LIST_URL = "/commonQuery/nbCollectorMeterList";
const COMMON_QUERY_NBCOLLECTOR_METER_CHECK_ADD_URL = "/commonQuery/nbCollectorMeterCheckAdd";
const COMMON_QUERY_NBCOLLECTOR_METER_CONFIG_URL = "/commonQuery/nbCollectorMeterConfig";
const COMMON_UPDATE_METER_KIND_URL = "/commonQuery/updateMeterKind";
const COMMON_MENUAL_CHECK_URL = "/commonQuery/manualCheck";
const COMMON_ADJUST_CUSTOMER_URL = "/commonQuery/adjustCustomerMeter";
const CUSTOMER_FIX_ALIPAY_URL = "/customer/fixAliPay";
const STATIS_METER_CHANGE_URL = "/statis/meterChange";
//服务端状态码
const HTTP_OK_CODE = 0;
const HTTP_FAIL_CODE = 1000;
const TOKEN_EXPIRED_CODE = 1004;
const TOKEN_NOT_EXIST = 1003;
const content_type_form = 'application/x-www-form-urlencoded;charset=UTF-8';
const content_type_json = 'application/json;charset=UTF-8';

//axios默认设置
axios.defaults.timeout = 1200000;//响应时间
axios.defaults.headers.post['Content-Type'] = content_type_form;
axios.defaults.withCredentials = true;
axios.defaults.baseUrl = BASE_API_URL;

//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {
    //在发送请求之前处理参数
    let userInfo = gloablConfig.getUserLocal();
    if(userInfo!=null){
        config.headers['UserId'] = userInfo.pId;
    }
    if(config.method  === 'post'){
		if(config.headers['Content-Type'] === content_type_json){
			config.data = JSON.stringify(config.data);
		}else{
			if(config.headers.post['Content-Type'] === content_type_form){
				if(gloablConfig.getObjectType(config.data)!=='FormData'){
					config.data = qs.stringify(config.data);
				}
			}else if(config.headers.post['Content-Type'] === content_type_json){
				config.data = JSON.stringify(config.data);
			}
		}
    }
    return config;
},(error) =>{
    return Promise.reject(error);
});

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) =>{
    //对响应数据做些事
    if(!res.data.success){
		if(res.data.code ===TOKEN_EXPIRED_CODE||res.data.code===TOKEN_NOT_EXIST){
			gloablConfig.removeUserInfo();
			gloablConfig.needLogin();
		}
        return Promise.resolve(res);
    }
    
    return res;
}, (error) => {
    return Promise.reject(error);
});

//返回一个Promise(发送post请求)
function fetchPost(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(response => {
                resolve(response);
            }, err => {
                reject(err);
            })
            .catch((error) => {
                reject(error)
            })
    })
}
function fetchPostWithForm(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params,{headers:{
                         'Content-Type': content_type_form,
                  }})
            .then(response => {
                resolve(response);
            }, err => {
                reject(err);
            })
            .catch((error) => {
                reject(error)
            })
    })
}
function fetchPostWithJson(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params,{headers:{
                         'Content-Type': content_type_json,
                  }})
            .then(response => {
                resolve(response);
            }, err => {
                reject(err);
            })
            .catch((error) => {
                reject(error)
            })
    })
}
////返回一个Promise(发送get请求)
function fetchGet(url, param) {
    return new Promise((resolve, reject) => {
        axios.get(url, {params: param})
            .then(response => {
                resolve(response)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
////返回一个Promise(发送post下载请求,)
function fetchPostFile(url, param) {
    return new Promise((resolve, reject) => {
        axios.post(url, param, {responseType:'blob'})
            .then(response => {
                resolve(response)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
//发送带二进制数据的post请求 
function fetchPostWithFiles(url, formData) {//formData是FormData对象
    return new Promise((resolve, reject) => {
        axios.post(url, formData)
            .then(response => {
                resolve(response);
            }, err => {
                reject(err);
            })
            .catch((error) => {
                reject(error)
            })
    })
}
function getLastUrl(urlStr){
	return this.BASE_API_URL+urlStr;
}
export default {
    BASE_API_URL,
	WEBSOCKET_URL,
    HTTP_OK_CODE,
    HTTP_FAIL_CODE,
	USER_CAPTCHA_URL,
	USER_LOGIN_URL,
	USER_LOGOUT_URL,
	USER_MENUS_URL,
	WATER_COMPANY_LIST_URL,
	EDIT_WATER_COMPANY_URL,
	ADD_WATER_COMPANY_URL,
	ROLE_LIST_URL,
	ROLE_AUTHORITY_URL,
	ROLE_AUTHORITY_ADD_URL,
	ROLE_AUTHORITY_EDIT_URL,
	USER_ADMIN_LIST_URL,
	USER_ADMIN_ADD_INFO_URL,
	USER_ADMIN_ADD_URL,
	//添加用户时，用户名校验
	USER_ADMIN_ADD_NAMECHECK_URL,
	
	USER_ADMIN_DELETE_URL,
	USER_ADMIN_UPDATE_URL,
	NEIGHBOR_SEARCH_LIST_URL,
	NEIGHBOR_DEPART_LIST_URL,
	NEIGHBOR_DEPART_ADD_URL,
	NEIGHBOR_DEPART_DELETE_URL,
	NEIGHBOR_DEPART_NEIGHBORIDS_URL,
	NEIGHBOR_DEPART_NEIGHBORS_URL,
	NEIGHBOR_DEPART_ADD_REL_URL,
	NEIGHBOR_DEPART_DEL_REL_URL,
	NEIGHBOR_LASTEST_LIST_URL,
	NEIGHBOR_GPRS_LIST_URL,
	NEIGHBOR_GPRS_CHECK_EXIST_URL,
	NEIGHBOR_GPRS_ADD_URL,
	NEIGHBOR_GPRS_EDIT_URL,
	NEIGHBOR_GPRS_DELETE_URL,
	NEIGHBOR_ADD_URL,
	NEIGHBOR_DELETE_URL,
	NEIGHBOR_UPDATE_URL,
	NEIGHBOR_CHECK_EXIST_URL,
	NEIGHBOR_CONFIG_PERIOD_ADD_URL,
	NEIGHBOR_CONFIG_PERIOD_DELETE_URL,
	NEIGHBOR_CONFIG_PERIOD_GET_URL,
	NEIGHBOR_CONFIG_PERIOD_UPDATE_URL,
	NEIGHBOR_LIST_LOU_URL,
	NEIGHBOR_LIST_DY_URL,
	NEIGHBOR_LIST_EXPORT_URL,
	NEIGHBOR_ALL_LIST_URL,
	GET_METER_USE_COUNT_URL,
	//查询欠费列表
	Static_LIST_OWE_URL,
	//查询收费率列表
	Static_LIST_ChargePercent_URL,
	//查询收费率图表
	Static_LIST_ChargePercentDraw_URL,
	//查询撤销记录列表
	Static_LIST_Undo_URL,
	//发短信提醒欠费用户
	CUSTOMER_SENDSMS_REMIND_URL,
	//短信发送记录
	STATIS_LIST_MESSAGE_LOG_URL,
	//短信发送记录列表通过名字查  分组小区
	STATIS_LIST_MESSAGE_LOG_BYNAME_URL,
	//结束抄表任务
	STOP_METER_TASK_DETAIL_URL,
	
	BASIC_PRICE_LIST_URL,
	BASIC_PRICE_ADD_URL,
	BASIC_PRICE_DELETE_URL,
	BASIC_PRICE_ADJUST_URL,
	SMS_TEMPLATE_LIST_URL,
	FAILURE_NOTICE_URL,
	SCANNING_TASK_LIST_URL,
	SCANNING_TASK_ADD_URL,
	SCANNING_TASK_DELETE_URL,
	SCANNING_TASK_UPDATE_URL,
	SCANNING_TASK_CHANGE_URL,
	SCANNING_TASK_NEIGHBORS_URL,
	SCANNING_TASK_RECORD_LIST_URL,
	SCANNING_TASK_ARREARAGE_CUSTOMERS_URL,
	SCANNING_TASK_ARREARAGE_SENDSMS_URL,
	SCANNING_TASK_SMS_LOGS_URL,
	CUSTOMER_LIST_WITH_NEIGHBOR_URL,
	CUSTOMER_METER_TRANSFER_URL,
	CUSTOMER_COLLECTORS_WITH_GPRS_URL,
	CUSTOMER_UPDATE_COLLECTOR_ADDR_URL,
	CUSTOMER_LIST_WITH_NUM_URL,
	CUSTOMER_METER_CHECK_EXIST_URL,
	CUSTOMER_UPDATE_URL,
	CUSTOMER_DELETE_URL,
	CUSTOMER_METERS_URL,
	CUSTOMER_METER_ADJUST_URL,
	CUSTOMER_METER_KIND_LIST_URL,
	CUSTOMER_METER_UPDTAE_URL,
	CUSTOMER_METER_DELETE_URL,
	CUSTOMER_METER_CHANGE_URL,
	CUSTOMER_CHECK_BY_APID_URL,
	CUSTOMER_METER__CHANGE_HISTORY_URL,
	CUSTOMER_ADD_URL,
	CUSTOMER_PRICE_KIND_LIST,
	CUSTOMER_METER_ADD_URL,
	CUSTOMER_BATCH_ADD_URL,
	CUSTOMER_METER_CHANGE_FAULT_URL,
	CUSTOMER_SENDSMS_REMIND_URL,
	CUSTOMER_ONE_GET_URL,
	CUSTOMER_UPDATE_INFO_URL,
	READ_METER_DISPATCH_ADDRESS_URL,
	READ_METER_LIST_URL,
	READ_METER_GPRS_LIST_URL,
	READ_METER_METER_LIST_URL,
	READ_METER_UPDATE_READ_URL,
	READ_METER_HISTORY_URL,
	READ_METER_EXPORT_HISTORY_URL,
	READ_METER_EXPORT_NEIGHBOR_EXCEL_URL,
	READ_METER_EXPORT_NEIGHBOR_ZIP_URL,
	READ_METER_4_NEIGHBOR_URL,
	READ_METER_4_COLLECTOR_URL,
	READ_METER_4_SINGLE_URL,
	READ_METER_4_CHOSED_URL,
	READ_METER_TASK_DETAIL_URL,
	READ_METER_TASKDETAIL_LIST_URL,
	READ_METER_4_ALL_URL,
	READ_METER_ALL_RESULT_URL,
	READ_METER_FINISH_TASK_MANUAL_URL,
	READ_METER_RESULT_ANALYSE_URL,
	READ_METER_RESULT_HANDLE_URL,
	READ_NON_REMOTE_METER_LIST_URL,
	READ_METER_EXPORT_ALL_URL,
	NON_REMOTE_EXPORT_URL ,
	NON_REMOTE_READ_LOG_ADD_URL,
	NON_REMOTE_READ_LOG_LIST_URL,
	NON_REMOTE_READ_DATA_ADD_URL,
	NON_REMOTE_READ_DATA_UPLOAD_URL,
	CHARGE_GET_CUSTOMER_INFO_URL,
	CHARGE_UPDATE_CUSTOMER_INFO_URL,
	CHARGE_CHANGE_PREPAYSIGN_URL,
	CHARGE_CHANGE_PREPAYSIGN_LOG_URL,
	CHARGE_GET_CUSTOMER_BY_IDCARD_URL,
	CHARGE_UPDATE_METER_PRICE_URL,
	CHARGE_UPDATE_DEREAD_URL,
	CHARGE_CHARGE_FEE_URL,
	CHARGE_CHARGE_LOG_LIST_URL,
	CHARGE_CANCEL_CHARGE_URL,
	CHARGE_DEDUCT_LOG_LIST,
	CHARGE_CANCEL_DEDUCT_URL,
	CHARGE_MINUS_DEREAD_URL,
	CHARGE_TO_VIRTUAL_URL,
	GET_METER_DEDUCT_STATIS_URL,
	CHARGE_SETTLE_SEARCH_URL,
	CHARGE_SETTLE_ALL_USE_COUNT_URL,
	CHARGE_SETTLE_SINGLE_URL,
	CHARGE_SETTLE_ALL_URL,
	CHARGE_WARNING_ALL_URL,
	CHARGE_POST_PAY_SETTLE_LOGS_URL,
	CHARGE_POST_PAY_LIST_URL,
	CHARGE_POST_PAY_CHARGE_URL,
	CHARGE_POST_PAY_WARNING_ALL_URL,
	CHARGE_MINUS_DEREAD_LOG_LIST_URL,
	CHARGE_UPDATE_PRICE_LOG_LIST_URL,
	CHARGE_SETTLE_EXPORT_EXCEPTION_URL,
	STATIS_GET_PAY_INFO_STATIS_URL,
	STATIS_PAY_INFO_STATIS_Print_URL,
	STATIS_List_Settle_Log_URL,
	STATIS_List_Settled_URL,
	STATIS_Settlelog_Print_URL,
	STATIS_LARGE_METER_USE_COUNT_URL,
	STATIS_LARGE_METER_NEIGHBORS_URL,
	STATIS_SIX_MONTH_NO_CHANGE_LIST_URL,
	STATIS_SIX_MONTH_NO_CHANGE_EXPORT_URL,
	STATIS_UNCHARGE_CUSTOMERS_URL,
	STATIS_UNCHARGE_CUSTOMERS_EXPORT_URL,
	STATIS_WATER_DEDUCT_LIST_URL,
	STATIS_WATER_DEDUCT_STATIS_URL,
	STATIS_WATER_DEDUCT_DRAW_URL,
	STATIS_WATER_DEDUCT_STATIS_ENTERPRISE_URL,
	STATIS_GETLOUS_URL,
	STATIS_LOULOGALL_URL,
	STATIS_LOU_PRINT_URL,
	STATIS_LIST_MESSAGE_LOG_URL,
	Static_LIST_OWE_URL,
	Static_LIST_ChargePercent_URL,
	Static_LIST_ChargePercentDraw_URL,
	Static_LIST_Undo_URL,
	MAIN_STATIS_URL,
	STATIS_ABNORMAL_CUSTOMER_LIST_URL,
	STATIS_ABNORMAL_CUSTOMER_EXPORT_URL,
	READ_METER_EXPORT_TYPE_LIST_URL,
	READ_METER_EXPORT_NEIGHBOR_YT_URL,
	READ_METER_EXPORT_NEIGHBOR_FS_URL,
	READ_METER_EXPORT_NEIGHBOR_WH_URL,
	READ_METER_EXPORT_NEIGHBOR_RC_URL,
	READ_METER_EXPORT_YT_ALL_URL,
	READ_METER_EXPORT_RC_ALL_URL,
	READ_METER_EXPORT_WH_ALL_URL,
	READ_METER_EXPORT_FS_ALL_URL,
	READ_METER_PATCH_TASK_URL,
	READ_METER_REFRESH_METER_URL,
	READ_METER_RESULT_ANALYSE_EXPORT_URL,
	READ_METER_LIHU_FAIL_METER_DATA_URL,
	READ_METER_LIHU_FAIL_METER_DATA_EXPORT_URL,
	READ_METER_LIST_BY_APID_URL,
	NEIGHBOR_CHANGE_GPRS_HISTORY_FLAG_URL,
	STATIS_OWE_EXPORT_URL,
	STATIS_WATER_DEDUCT_STATIS_EXPORT_URL,
	READ_METER_UPDATE_METER_OK_URL,
	STATIS_DEDUCT_EXPORT_URL,
	USER_ADMIN_RESET_PWD_URL,
	USER_ADMIN_EDIT_PWD_URL,
	CUSTOMER_EXPORT_URL,
	READ_METER_EXPORT_ALL_EXCEL_URL,
	SYSTEM_GET_GPRS_ONLINE_LOG_URL,
	SET_METER_VALVE_STATE_URL,
	READ_METER_EXPORT_YT_TOTAL_URL,
	READ_METER_RECENT_HISTORY_URL,
	READ_METER_IMPORT_FAILDATA_URL,
	READ_METER_REBOOT_GPRS_URL,
	STATIS_MINUS_LIST_URL,
	STATIS_MINUS_EXPORT_URL,
	GET_NB_COLLECTOR_LIST_URL,
	ADD_NB_COLLECTOR_URL,
	EDIT_NB_COLLECTOR_URL,
	DELETE_NB_COLLECTOR_URL,
	DELETE_NB_COLLECTOR_COMMAND_URL,
	DELETE_NB_COLLECTOR_COMMAND_ID_URL,
	QUERY_NB_COLLECTOR_COMMAND_URL,
	DISPATCH_ADDR_NB_COLLECTOR_URL,
	ELEC_QUERY_METER_LIST_URL,
	ELEC_ADD_METER_URL,
	ELEC_ADD_TASK_URL,
	SEND_SETUP_WORK_MODE_COMMAND_URL,
	SEND_SETUP_UPLOAD_DATE_COMMAND_URL,
	METER_MONITOR_MAP_INFO_URL,
	METER_MONITOR_METER_INFO_URL,
	METER_MONITOR_REAL_TIME_STATIS_URL,
	METER_MONITOR_REAL_TIME_STATIS_EXPORT_URL,
	METER_MONITOR_FLOW_STATIS_URL,
	METER_MONITOR_FLOW_STATIS_EXPORT_URL,
	METER_MONITOR_INTERVAL_FLOW_STATIS_URL,
	METER_MONITOR_LINK_STATUS_URL,
	METER_MONITOR_LINK_EXPORT_URL,
	METER_MONITOR_YOY_STATIS_URL,
	METER_MONITOR_YOY_STATIS_EXPORT_URL,
	METER_MONITOR_YOY_STATIS_CHART_URL,
	METER_MONITOR_EDIT_OVERFLOW_URL,
	METER_MONITOR_MIN_FLOW_LIST_URL,
	METER_MONITOR_MIN_FLOW_LIST_EXPORT_URL,
	METER_MONITOR_MIN_FLOW_DETAIL_URL,
	METER_MONITOR_ANALYSIS_URL,
	METER_MONITOR_ALL_LIST_URL,
	METER_MONITOR_ADD_URL,
	METER_MONITOR_EDIT_URL,
	METER_MONITOR_QUERY_METER_URL,
	METER_MONITOR_QUERY_DETAIL_URL,
	METER_MONITOR_DATA_EXPORT_URL,
	EXPORT_NB_COLLECTOR_URL,
	QUERY_GPRS_RESULT_URL,
	METER_RESET_READ_DATA_URL,
	METER_FIX_STATUS_URL,
	QUERY_NBMETER_HISTORY_URL,
	COMMON_QUERY_UPDATE_NBCOLLECTOR_METER_URL,
	COMMON_QUERY_NBCOLLECTOR_METER_LIST_URL,
	COMMON_QUERY_NBCOLLECTOR_METER_CHECK_ADD_URL,
	COMMON_QUERY_NBCOLLECTOR_METER_CONFIG_URL,
	COMMON_UPDATE_METER_KIND_URL,
	COMMON_ADJUST_CUSTOMER_URL,
	NEIGHBOR_DEPART_NO_ORDER_URL,
	COMMON_MENUAL_CHECK_URL,
	CUSTOMER_FIX_ALIPAY_URL,
	STATIS_METER_CHANGE_URL,
	READ_METER_DATA_CONTRAST_URL,
    fetchPost,
    fetchPostWithForm,
    fetchPostWithJson,
    fetchPostFile,
	fetchPostWithFiles,
    fetchGet,
	getLastUrl,
}
